import $ from 'jquery';

// file upload functionality
$('.form-field input[type="file"]').on('change', () => {
  var file = $(this).val();
  var text = file.substr(12, file.length);

  $(this).prev('span').text(text);
});
